import { createContext, useContext } from 'react'

import { SwimlaneSummary } from '@flowx/designer/modules/core/dictionary/swimlane.dictionary'

import { LaneResizeBounds } from './bpmn-graph.mapper'

import { DirectionVertical } from '../../dictionary/geometry.types'

export interface SwimlaneUiState {
  selectedLaneId: SwimlaneSummary['id'] | null
  readonly: boolean
  /** Swimlane ids ordered by their vertical position, used for move/delete disabled states */
  orderedLaneIds: SwimlaneSummary['id'][]
  /** Absolute node bounds per lane that clamp edge resizes */
  resizeBounds: Map<SwimlaneSummary['id'], LaneResizeBounds>
  selectLane: (id: SwimlaneSummary['id'] | null) => void
  addLane: (swimlane: SwimlaneSummary, direction: DirectionVertical) => void
  moveLane: (swimlane: SwimlaneSummary, direction: DirectionVertical) => void
  deleteLane: (swimlane: SwimlaneSummary) => void
  renameLane: (swimlane: SwimlaneSummary, newName: string) => void
  resizeLane: (
    swimlane: SwimlaneSummary,
    layoutOptions: { x: number; y: number; width: number; height: number }
  ) => void
}

export const SwimlaneUiContext = createContext<SwimlaneUiState | null>(null)

export function useSwimlaneUi(): SwimlaneUiState {
  const context = useContext(SwimlaneUiContext)
  if (!context) {
    throw new Error('useSwimlaneUi must be used within BpmnFlowCanvas')
  }

  return context
}
